export default __webpack_public_path__ + "static/m2-73d016b02561066fdd401e6876f365f6.jpg";